export default "__VITE_ASSET__c60b86af__"